import React from 'react';
import { useHistory, Link, Redirect } from 'react-router-dom';
import successFreeSearchesHero from '../../images/successFreeSearchesHero.svg';
import classnames from 'classnames';
import styles from './successFreeSearchSplash.module.scss';
import BackgroundImages from '../Background/BackgroundImages';
import EmailVerification from '../EmailVerification/EmailVerification';

interface HistoryState {
  from: string;
}

const SuccessFreeSearchSplash = () => {
  const history = useHistory();
  const historyState: unknown = history.location.state;

  if (
    historyState === undefined ||
    (historyState !== undefined &&
      (historyState as HistoryState).from !== '/create')
  ) {
    return <Redirect to={{ pathname: '/requests/requester/active/nav' }} />;
  }

  return (
    <div className={classnames('container-xl fix-bg-images')}>
      <EmailVerification />
      <BackgroundImages />
      <div className={styles.successContainer}>
        <div className={classnames('position-absolute', styles.textContent)}>
          <h1>Success!</h1>
          <p>Your request has been submitted to our network of data vendors.</p>
          <p>
            <b>
              If vendors on Nomad Data can fulfill your request today, you can
              expect a response within the next 24 hours. If your requested data
              is not available today, but becomes available over the next
              several months, you will be contacted then.
            </b>
          </p>
          <Link
            to="/requests/requester/active/nav"
            className={classnames('btn btn-primary', styles.goToMyRequests)}
          >
            go to my requests
          </Link>
        </div>
        <div className="d-flex justify-content-center">
          <img
            className="img-fluid"
            src={successFreeSearchesHero}
            alt="successFreeSearchesHeroImage"
          ></img>
        </div>
      </div>
    </div>
  );
};

export default SuccessFreeSearchSplash;
